import get from 'lodash.get';

const getFingerprintApiUrl = (rootState) =>
  get(rootState, 'config.common.fingerprint.proxied_api_url', null);

export default getFingerprintApiUrl;
